export const RightArrowSVG = (props) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m10 16 4-4-4-4"
      stroke="#dcdfe1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
